import React from "react";
import PropTypes from "prop-types";
import { Alert, Card, Button, FormCheckbox } from "shards-react";
import CustomizedTable from "../table/CustomizedTable";
import CustomizedCardHeader from "../customized-card-header/CustomizedCardHeader";
import { useNavigate } from "react-router-dom";

import {
    CustomizedCardBody,
    SpanMessage,
    SubTitle,
    CustomizedTd,
    ButtonAsLink,
    ButtonAsLinkPrimary
} from "./style";
import GenericUtils from "../../utils/GenerictUtils";

const ManagerCredentials = ({
    alertValues,
    menuList,
    headTitles,
    credentialList,
    closeAlert,
    deleteItem,
    name = "",
    handleCheckItem,
    handleDeleteSelectedCredentials,
    handleSelectAllCredentials
}) => {
    const navigate = useNavigate();

    const hasCredentialCheck = _credentialsList => {
        return _credentialsList?.some(c => c?.checked);
    };

    return (
        <Card small className="mb-4">
            <CustomizedCardHeader
                className={"border-bottom"}
                initialName={`Credenciais: ${name}`}
                menuList={menuList}
            />
            <CustomizedCardBody>
                <Alert
                    className="mb-3"
                    open={alertValues.isAlertVisible}
                    dismissible={closeAlert}
                    theme={alertValues.theme}
                >
                    {alertValues.message}
                </Alert>
                {credentialList.length > 0 ? (
                    <React.Fragment>
                        <SubTitle>Credenciais do usuário</SubTitle>
                        <div style={{ height: 20 }}>
                            {hasCredentialCheck(credentialList) ? (
                                <Button
                                    size={"sm"}
                                    pill
                                    theme="danger"
                                    onClick={() =>
                                        handleDeleteSelectedCredentials()
                                    }
                                >
                                    Revogar credenciais selecionadas
                                </Button>
                            ) : (
                                ""
                            )}
                        </div>
                        <CustomizedTable headTitles={headTitles}>
                            <ButtonAsLink
                                size={"md"}
                                style={{
                                    fontWeight: "bold",
                                    color: "#52816d",
                                    marginBottom: 20,
                                    textDecoration: "underline"
                                }}
                                onClick={() => handleSelectAllCredentials()}
                            >
                                Selecionar todas as credenciais
                            </ButtonAsLink>
                            <React.Fragment>
                                {credentialList.map((credential, id) => (
                                    <tr key={`${credential}-${id}`}>
                                        <CustomizedTd>
                                            <FormCheckbox
                                                checked={credential?.checked}
                                                onChange={() =>
                                                    handleCheckItem(credential)
                                                }
                                            />
                                            <CredentialInfoDetailsComponent
                                                credential={credential}
                                            />
                                        </CustomizedTd>
                                        <td>
                                            <Button
                                                theme="secondary"
                                                className="cy--remove-credential"
                                                onClick={() =>
                                                    deleteItem(
                                                        credential.clientId
                                                    )
                                                }
                                            >
                                                Revogar
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        </CustomizedTable>
                    </React.Fragment>
                ) : (
                    <SpanMessage>
                        <SubTitle>
                            Este usuário não possui credenciais.
                        </SubTitle>
                        <SubTitle>
                            Para gerar uma nova credencial ou outras
                            informações,{" "}
                            <ButtonAsLinkPrimary
                                theme="link"
                                onClick={() => navigate("/getting-started")}
                            >
                                acesse a documentação
                            </ButtonAsLinkPrimary>
                        </SubTitle>
                    </SpanMessage>
                )}
            </CustomizedCardBody>
        </Card>
    );
};

const CredentialInfoDetailsComponent = props => {
    const { credential = {} } = props;
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                margin: "0px",
                padding: "0px",
                justifyContent: "center",
                alignContent: "center"
            }}
        >
            <p
                style={{
                    margin: "0px"
                }}
            >
                {credential.clientId}{" "}
                {credential?.lastAuth?.userAgent
                    ? `- ${credential?.lastAuth?.userAgent}`?.toUpperCase()
                    : ""}
            </p>
            <p
                style={{
                    fontSize: "12px",
                    margin: "0px"
                }}
            >
                {credential?.lastAuth?.date && credential?.lastAuth?.ip
                    ? `${GenericUtils.formatCredentialDate(
                          credential?.lastAuth?.date
                      )} - IP: ${credential?.lastAuth?.ip}`
                    : "Não usada até o momento"}
            </p>
        </div>
    );
};

ManagerCredentials.propTypes = {
    alertValues: PropTypes.object,
    menuList: PropTypes.array,
    headTitles: PropTypes.array,
    credentialList: PropTypes.array,
    closeAlert: PropTypes.func,
    deleteItem: PropTypes.func,
    name: PropTypes.string
};
export default ManagerCredentials;
